import type { CallRecordListItem } from '@/hooks/use-call-records'

/** FIFO: earliest started (or created) first; missing times sort last. */
export function sortActiveCalls(rows: CallRecordListItem[]): CallRecordListItem[] {
  return [...rows].sort((a, b) => {
    const ka = a.started_at || a.created_at || ''
    const kb = b.started_at || b.created_at || ''
    if (ka !== kb) {
      if (!ka) return 1
      if (!kb) return -1
      return ka.localeCompare(kb)
    }
    return a.id.localeCompare(b.id)
  })
}

/** Most recently ended first; tie-break on updated_at / created_at. */
export function sortCompletedCalls(rows: CallRecordListItem[]): CallRecordListItem[] {
  return [...rows].sort((a, b) => {
    const ea = a.ended_at || ''
    const eb = b.ended_at || ''
    if (ea !== eb) {
      if (!ea) return 1
      if (!eb) return -1
      return eb.localeCompare(ea)
    }
    const ua = a.updated_at || ''
    const ub = b.updated_at || ''
    if (ua !== ub) return ub.localeCompare(ua)
    return b.created_at.localeCompare(a.created_at)
  })
}
